import React, { useContext } from 'react';
import { Link } from '@reach/router';

import { AuthContext } from '../AuthContext';

// import { PageTitle } from '../components/PageTitle';
import LoginForm from '../components/LoginForm';

export const Login = () => {

	const { activateAuth } = useContext(AuthContext);

	return (
		<div className="block-center mt-4 wd-xl">
			<div className="card card-flat">
				<div className="card-header text-center">
					<Link to='/'>
						<img style={{ marginBottom: 25 }} width='300' height='auto' src="img/alex_logo_cropped.png" alt="alex-logo"/>
					</Link>
					{/* <label style={{ fontSize: 34, fontWeight: 'bold' }}>ALEX</label> */}
				</div>
				<div className="card-body">
					<p className="text-center py-2">LOGIN TO YOUR ACCOUNT.</p>
					<LoginForm activateAuth={activateAuth} />
					{/* <p class="pt-3 text-center">Need to Signup?</p><a class="btn btn-block btn-secondary" href="register.html">Register Now</a> */}
				</div>
			</div>
			<div class="p-3 text-center">
				<span class="mr-2">&copy;</span>
				<span>Powered By</span>
				<span><img width='150' height='auto' src="img/vibal_logo.png" alt="vibal-logo" /></span>
			</div>
		</div>
	);
};